"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyRef = exports.mergeRefs = void 0;
var react_1 = require("react");
function mergeRefs(ref1, ref2) {
    return function (element) {
        assignRef(ref1, element);
        assignRef(ref2, element);
    };
}
exports.mergeRefs = mergeRefs;
function assignRef(ref, element) {
    if (typeof ref === 'function') {
        ref(element);
    }
    else if (ref) {
        // @ts-ignore
        ref.current = element;
    }
}
function useLazyRef(callback) {
    var value = (0, react_1.useState)(callback)[0];
    var ref = (0, react_1.useRef)(value);
    return ref;
}
exports.useLazyRef = useLazyRef;
